
import { Component, Vue } from 'vue-property-decorator'
import UserImg from '@/components/PersonSelect.vue'
import { Mutation } from 'vuex-class'
@Component({
  components: {
    UserImg
  }
})
export default class Login extends Vue {
  @Mutation('setName') setName !: (name: string) => void
  private name = ''

  onLogin () {
    if (this.name === '') {
      alert('Name is not set!')
      return false
    }
    this.setName(this.name)
    this.$router.push('/chatroom')
  }
}
